export enum ColumnHeadersEnum {
    'TEST_GROUP_ID' = 'GROUP_ID',
    'TEST_GID' = 'GID TEST',
    'TEST_DESIG' = 'TEST ENTRY DESIGNATION',
    'STANDARD_GROUP_ID' = 'GROUP_ID',
    'STANDARD_GID' = 'GID STANDARD',
    'STANDARD_DESIG' = 'STANDARD ENTRY DESIGNATION',
}
